import {configureStore} from '@reduxjs/toolkit';
import providerItemsReducer from './slices/providerItemsSlice';
import autoCompleteItemsReducer from './slices/autoCompleteSlice';

export const store = configureStore({
  reducer: {
      providerItems: providerItemsReducer,
      autoCompleteItems: autoCompleteItemsReducer
  },
});